import {
	MsalGuardConfiguration,
	MsalInterceptorConfiguration
} from '@azure/msal-angular';
import {
	msalConfig,
	protectedResources
} from '../../injection-tokens/auth-config.injection-token';
import {
	InteractionType,
	IPublicClientApplication,
	PublicClientApplication
} from '@azure/msal-browser';

export class AuthenticationServiceFactory
{
	public static msalInstanceFactory(): IPublicClientApplication
	{
		return new PublicClientApplication(msalConfig);
	}
	public static msalGuardConfigFactory(): MsalGuardConfiguration
	{
		return {
			interactionType: InteractionType.Redirect
		};
	}
	public static msalInterceptorConfigFactory(): MsalInterceptorConfiguration
	{
		const protectedResourceMap = new Map<string, Array<string>>();
		protectedResources.forEach(item => protectedResourceMap.set(item.endpoint, item.scopes));		
		return {
			interactionType: InteractionType.Redirect,
			protectedResourceMap
		};
	}
}
